import * as types from '../../actionTypes';

const initialState = {
    savePatient: [],
    error: {},
    loading: false,
}



export  const savePatientReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SAVE_PATIENT_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.SAVE_PATIENT_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                savePatient: action.payload,
                loading: false,
                error: {}
            }
        case types.SAVE_PATIENT_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                savePatient: []
            }
        
        default:
            return state;
    }
}